// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__jNzKP","accordion":"NavSection_accordion__s9Ws2","accordionDetails":"NavSection_accordionDetails__1cJ-e"};